import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Usuario } from '../models';

@Injectable({
	providedIn: 'root',
})
export class UsuarioService {
	constructor(private _apiService: ApiService) {}

	saveUsuario(user) {
		localStorage.setItem('user', JSON.stringify(user));
	}

	getUsuario() {
		return JSON.parse(localStorage.getItem('user'));
	}

	destroyUsuario() {
		window.localStorage.removeItem('user');
		window.localStorage.removeItem('currentuserPermisos');
	}

	setCurrentUsuario() {
		this._apiService.get('/user').subscribe(
			response => {
				if (response.result === 'ok') {
					const usuario = new Usuario(response.data);
					this.saveUsuario(usuario);
					window.localStorage['currentuserPermisos'] = usuario.permisos;
				}
			},
			err => this.destroyUsuario()
		);
	}
}
